// extracted by mini-css-extract-plugin
export default {"mainMenuOptionsContainer":"voaI099KyDfRg682WgD9","small":"q9qipAtOMDTAzsPOWRyq","popupClasses":"acbxrDSZtXYy3vYIZQlg","listItem":"pc7IY_i2YSMMOYCrw137"};